import Partner from "./partner";

const PlatformService = {
  Partner,
};

export default PlatformService;
